import * as React from 'react';
import { Text } from 'wix-ui-tpa';
import { classes } from './Attachment.st.css';
var Attachment = function (_a) {
    var url = _a.url, iconLink = _a.iconLink, title = _a.title, onAttachmentClick = _a.onAttachmentClick, tabIndex = _a.tabIndex;
    return (React.createElement("a", { tabIndex: tabIndex, className: classes.Attachment, href: url, onClick: function () { return onAttachmentClick && onAttachmentClick(); }, target: "_blank" },
        React.createElement("img", { className: classes.Icon, src: iconLink }),
        React.createElement(Text, { className: classes.Title }, title)));
};
export default Attachment;
//# sourceMappingURL=Attachment.js.map